import React from 'react';
import { Route, Switch } from 'react-router';

import Comments from './Comments';
import Review from './Review';
import Errors from './Errors';
import Submit from './Submit';
import Print from './Print/index';
import SectionNotFound from '../shared/SectionNotFound';

const Package = () => (
  <div className="section-view">
    <Switch>
      <Route path="/form/package/comments" component={Comments} />
      <Route path="/form/package/review" component={Review} />
      <Route path="/form/package/errors" component={Errors} />
      <Route path="/form/package/submit" component={Submit} />
      <Route path="/form/package/print" component={Print} />
      <Route component={SectionNotFound} />
    </Switch>
  </div>
);

export default Package;
